import { useEffect, useRef, useState } from "react";
import { select } from "d3-selection";
import { zoom, zoomIdentity } from "d3-zoom";
import { VIEW_W, VIEW_H } from "@/components/map/MapParts";

const MAX_K = 6;

/** Pinch / double-tap / ctrl+wheel zoom on the map svg; single-finger drag only pans once zoomed so the page keeps scrolling. */
export function useMapZoom() {
  const svgRef = useRef(null);
  const zoomRef = useRef(null);
  const [transform, setTransform] = useState(zoomIdentity);

  useEffect(() => {
    const svg = select(svgRef.current);
    const z = zoom()
      .scaleExtent([1, MAX_K])
      .translateExtent([[0, 0], [VIEW_W, VIEW_H]])
      .extent([[0, 0], [VIEW_W, VIEW_H]])
      .filter((e) => {
        if (e.type === "wheel") return e.ctrlKey || e.metaKey;
        if (e.type === "touchstart" && e.touches.length === 1) return svg.node().__zoom.k > 1;
        return !e.button;
      })
      .on("zoom", (e) => {
        setTransform(e.transform);
        svg.style("touch-action", e.transform.k > 1 ? "none" : "pan-y pinch-zoom");
      });
    svg.call(z).on("dblclick.zoom", null).style("touch-action", "pan-y pinch-zoom");
    zoomRef.current = z;
    return () => svg.on(".zoom", null);
  }, []);

  const by = (factor) => select(svgRef.current).transition().duration(250).call(zoomRef.current.scaleBy, factor);
  const reset = () => select(svgRef.current).transition().duration(300).call(zoomRef.current.transform, zoomIdentity);

  return { svgRef, transform, zoomIn: () => by(1.6), zoomOut: () => by(1 / 1.6), reset };
}
